export const CreativePictures = [
    {
        "id": 1,
        "title" : "YaYa",
        "description" : "拍摄于伦敦自然历史博物馆 Photographed at the Natural History Museum, London ",
        "firstPic" : "https://s2.loli.net/2025/03/31/iwGTHEtCzvxBmen.jpg",
        "pics" : [ {
          "src" : "https://s2.loli.net/2025/03/31/25Jikq3I8A1OzXw.jpg",
          "description" : ""
        }, {
          "src" : "https://s2.loli.net/2025/03/31/dhobGxFK1IqHvir.jpg",
          "description" : ""
        }, {
          "src" : "https://s2.loli.net/2025/03/31/8PCYq1bH3XadWEG.jpg",
          "description" : ""
        }, {
          "src" : "https://s2.loli.net/2025/03/31/BaLj8i2N3TUSCsJ.jpg",
          "description" : ""
        }, {
          "src" : "https://s2.loli.net/2025/03/31/iwGTHEtCzvxBmen.jpg",
          "description" : ""
        } ]
      },
      {
        "id": 2,
        "title" : "Covent Garden",
        "description" : "拍摄于伦敦考文特花园 Photographed in Covent Garden, London",
        "firstPic" : "https://files.seeusercontent.com/2026/06/27/2Iin/dac6c97a_SAPRVyIxOok9CNb.jpg",
        "pics" : [ {
          "src" : "https://files.seeusercontent.com/2026/06/27/9oQl/6a570953_NPLF5HtJAganyMV.jpg",
          "description" : ""
        }, {
          "src" : "https://files.seeusercontent.com/2026/06/27/dg2D/9a42b145_u371R8P2znG9doH.jpg",
          "description" : ""
        }, {
          "src" : "https://files.seeusercontent.com/2026/06/27/Gtw5/d9d5e2d7_9WqIM8FXwkueDjU.jpg",
          "description" : ""
        }, {
          "src" : "https://files.seeusercontent.com/2026/06/27/hJs5/134aa48e_tynN6WPK45FpHhM.jpg",
          "description" : ""
        }, {
          "src" : "https://files.seeusercontent.com/2026/06/27/2Iin/dac6c97a_SAPRVyIxOok9CNb.jpg",
          "description" : ""
        },{
          "src" : "https://files.seeusercontent.com/2026/06/27/uaX7/b3c20bc1_Rgy2kuVG8MwQIbf.jpg",
          "description" : ""
        }
       ]
      },
      {
        "id": 3,
        "title" : "Cyberpunk",
        "description" : "赛博朋克风格 Cyberpunk style",
        "firstPic" : "https://files.seeusercontent.com/2026/06/27/nlX4/a942b93c_arHQpgmq3txyfVF.jpg",
        "pics" : [ {
          "src" : "https://files.seeusercontent.com/2026/06/27/haD0/88bbad50_Te57vERNtOynrcl.jpg",
          "description" : ""
        }, {
          "src" : "https://files.seeusercontent.com/2026/06/27/nlX4/a942b93c_arHQpgmq3txyfVF.jpg",
          "description" : ""
        }, {
          "src" : "https://files.seeusercontent.com/2026/06/27/4Zsc/29d5d95d_Im97AZk4WFytRqL.jpg",
          "description" : ""
        }, {
          "src" : "https://files.seeusercontent.com/2026/06/27/W1xv/8da34ac5_kxvaAIhGP5qNEuJ.jpg",
          "description" : ""
        } ]
      },
  {
        "id": 4,
        "title" : "Covent Garden",
        "description" : "拍摄于伦敦考文特花园 Photographed in Covent Garden, London",
        "firstPic" : "https://files.seeusercontent.com/2026/06/27/Vew8/ff741508_udtrCkgTnHSlKMV.jpg",
        "pics" : [ {
          "src" : "https://files.seeusercontent.com/2026/06/27/Yyg4/21fec098_yrvT3aMKtmGnxJV.jpg",
          "description" : ""
        }, {
          "src" : "https://files.seeusercontent.com/2026/06/27/Uk7z/ace7e3d7_XfGsD1eWjAVnIzQ.jpg",
          "description" : ""
        }, {
          "src" : "https://files.seeusercontent.com/2026/06/27/j9Vk/f76e7c34_cKZJkx5G3NCSawP.jpg",
          "description" : ""
        }, {
          "src" : "https://files.seeusercontent.com/2026/06/27/Vew8/ff741508_udtrCkgTnHSlKMV.jpg",
          "description" : ""
        },
      {
          "src" : "https://files.seeusercontent.com/2026/06/27/Oif2/12aa8e16_OSaTl8nyLft9uwZ.jpg",
          "description" : ""
        } ]
      },
      {
        "id": 5,
        "title" : "Covent Garden",
        "description" : "拍摄于伦敦考文特花园 Photographed in Covent Garden, London",
        "firstPic" : "https://s2.loli.net/2025/03/31/WyZ4MazlgXxjA5T.jpg",
        "pics" : [ {
          "src" : "https://s2.loli.net/2025/03/31/WyZ4MazlgXxjA5T.jpg",
          "description" : ""
        }, {
          "src" : "https://files.seeusercontent.com/2026/06/27/9vaW/426f4df4_HY8fuIDLgKtW9hC.jpg",
          "description" : ""
        } ]
      }
];
